// Fields that carry the customer's own price slider selection.
const PRICE_FILTER_FIELDS = ['priceFrom', 'priceTo'];

// Fields that change how results are listed without filtering them.
const NON_FILTER_FIELDS = ['page', 'sortOrder'];

const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

const toBoundedPrice = (value, fallback, min, max) => {
  const numericValue = Number(value);

  if (value === null || value === undefined || value === '' || !Number.isFinite(numericValue)) {
    return fallback;
  }

  return clamp(numericValue, min, max);
};

/**
 * Splits a filter payload into a price slider move and a change to any other
 * filter, so the caller can tell the two apart. Changing a non-price filter
 * searches on the CMS price boundary again; moving the slider searches on the
 * customer's own range.
 */
export const classifyFilterChange = (payload) => {
  const changedFields = Object.keys(payload || {});

  return {
    priceChanged: changedFields.some((field) => PRICE_FILTER_FIELDS.includes(field)),
    filterChanged: changedFields.some(
      (field) => !PRICE_FILTER_FIELDS.includes(field) && !NON_FILTER_FIELDS.includes(field)
    ),
  };
};

/**
 * Works out where the price slider handles sit after a search run on the full
 * CMS price boundary. The handles show the price range of the packages that
 * came back, clamped to the CMS boundary. A search that returns no priced
 * results falls back to the boundary itself, so the slider always reflects the
 * range that was actually searched.
 */
export const getPriceRangeFromSearchResults = ({
  minimumPricePerCurrency,
  maximumPricePerCurrency,
  currencyCode,
  minPrice,
  maxPrice,
}) => {
  const boundaryMin = Number(minPrice);
  const boundaryMax = Number(maxPrice);

  const findTotalPrice = (prices) =>
    prices?.find((price) => price.currency === currencyCode)?.totalPrice;

  return {
    priceFrom: toBoundedPrice(
      findTotalPrice(minimumPricePerCurrency),
      boundaryMin,
      boundaryMin,
      boundaryMax
    ),
    priceTo: toBoundedPrice(
      findTotalPrice(maximumPricePerCurrency),
      boundaryMax,
      boundaryMin,
      boundaryMax
    ),
  };
};
